<template>
  <div>
    <div class="container mt8">
      <img src="../../../../../../src/assets/img/mypage/mykeepin_ic.png" alt=""><span class="text ml4">
        {{ $t('Verification.common.auth')}}
      </span>
      <ul class="list">
        <li>
          {{$t('Verification.step2.mykeepin[0]')}}
        </li>
        <li>
          {{$t('Verification.step2.mykeepin[1]')}}
        </li>
        <li>
          {{$t('Verification.step2.mykeepin[2]')}}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="scss" scoped>
.container {
  padding: 13px 12px;
  border-radius: 4px;
  background-color: #f7f8fa;
  .text {
    font-weight: 500;
    line-height: 24px;
  }
  ul.list {
    list-style: none;
    li {
      position: relative;
      padding-left: 8px;
      margin-top: 8px;
      &:before {
        content: '';
        position: absolute;
        top: 7px;
        left: 0;
        width: 4px;
        height: 4px;
        border-radius: 10px;
        background-color: #333;
      }
    }
  }
}
</style>